module.exports = __webpack_public_path__ + "img/diashow (12).9e26d3d.jpg";